import PropTypes from 'prop-types';
// import moment from 'moment';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';
import shortid from 'shortid';

import {
  Button,
  Price,
} from 'components';

import defaultThumb from 'img/logo/default-thumb.png';

// Hardcoded project creation settings
const PROJECT_DUE_DATE = new Date();
const PROJECT_STATUS = 'concept';
const PROJECT_TYPE = 'new';

export default class SystemInfoModal extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.state = {
      products: [],
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    const data = [];
    const { attributes: { products } } = this.props.system;

    if (products) {
      products.forEach((product) => {
        data.push({
          ...product,
          id: shortid.generate(),
        });
      });

      this.setState({ products: data });
    }
  }

  /* Event handlers */

  onSubmit() {
    const {
      intl,
      onSubmit,
      projectsCreate,
      projectSetSystem,
      system,
    } = this.props;

    const projectPayload = {
      data: {
        attributes: {
          due_date: PROJECT_DUE_DATE,
          name: system.attributes.product_names[intl.locale], // Using the name of the system
          status: PROJECT_STATUS,
          type: PROJECT_TYPE,
        },
      },
    };

    projectsCreate(projectPayload).then((response) => {
      const systemPayload = {
        data: {
          id: response.id,
          relationships: {
            original_system: {
              data: {
                id: system.id,
                type: 'System',
              },
            },
          },
        },
      };

      projectSetSystem(systemPayload).then(() => {
        browserHistory.push(`/systems/${response.id}`);
        onSubmit();
      });
    });
  }

  /* Render */

  render() {
    const thumb = this.props.system.attributes.sketch || defaultThumb;

    return (
      <div className="system-detail">
        <div className="system-detail__content">
          <div className="system-detail__schema">
            <img alt="Thumbnail" src={thumb} />
          </div>
          <div className="system-detail__products">
            <div className="system-detail__products__title">
              <FormattedMessage id="systems.info.products" />
            </div>
            <div className="system-detail__products__list">
              {this.renderProducts()}
            </div>
          </div>
        </div>
        <Button
          className="system-detail__button-select button button-bg-yellow"
          disabled={this.props.loading}
          loading={this.props.loading}
          onClick={this.onSubmit}
        >
          <FormattedMessage id="systems.info.select" />
        </Button>
      </div>
    );
  }

  renderProducts() {
    const { intl: { locale } } = this.props;
    const { products } = this.state;
    const productNodes = [];

    products.forEach((item) => {
      const {
        brand,
        id,
        url,
        name,
        price,
      } = item;

      productNodes.push((
        <div className="system-detail__product" key={`product-${id}`}>
          <div className="system-detail__product__image">
            <img src={url} alt="" />
          </div>
          <div className="system-detail__product__info">
            <div className="system-detail__product__title-row">
              <div className="system-detail__product__label">
                <div className="system-detail__product__title">
                  {name[locale]}
                </div>
                <div className="system-detail__product__subtitle">
                  {brand}
                </div>
              </div>
              <div className="system-detail__product__value">
                <div className="system-detail__product__price">
                  <Price minimal value={price} vatExcluded />
                </div>
              </div>
            </div>
            {this.renderProductRows(item)}
          </div>
        </div>
      ));
    });

    return productNodes;
  }

  renderProductRows(item) {
    const rows = [];

    ['sap'].forEach((property) => {
      rows.push((
        <div className="system-detail__product__row" key={`product-row--${property}`}>
          <div className="system-detail__product__label">
            <FormattedMessage id={`systems.info.${property}`} />
          </div>
          <div className="system-detail__product__value">
            {item[property]}
          </div>
        </div>
      ));
    });

    return rows;
  }
}

SystemInfoModal.propTypes = {
  intl: PropTypes.object,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  projectsCreate: PropTypes.func,
  projectSetSystem: PropTypes.func,
  system: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/views/systems/info-modal/index.jsx